import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { toggleSidebarNav } from '../../../actions/components/page-layout';

const initialState = {
  sidebarNavExpanded: true
};

const toggleSidbarNavHandler = action => ({
  [action.toString()]: ({ sidebarNavExpanded, ...state }) =>
    set('sidebarNavExpanded', !sidebarNavExpanded, state)
});

export default createReducer(initialState, {
  ...toggleSidbarNavHandler(toggleSidebarNav)
});
